<template>
  <div
    class="sliding-line-cards overflow-hidden"
  >
    <div
      v-for="(doctorRatesByLine, lineIndex) in doctorRatesByLines"
      :key="`doctor-rates-${lineIndex}`"
      class="d-flex align-self-center"
    >
      <div
        class="sliding-line-cards__line gc-4 px-4"
        :class="lineIndex === 0 ? 'align-end' : 'align-start'"
        :style="{ animationPlayState: animationState }"
      >
        <div
          v-for="(doctorRate, doctorRateIndex) in doctorRatesByLine"
          :key="`doctor-rate-${doctorRate.doctor.id}-${doctorRateIndex}`"
          class="d-flex flex-column gr-8 pa-6 elevation-1 rounded-sm"
          :style="{ width: doctorRate.width }"
        >
          <div class="text-body-1 text--text">
            {{ doctorRate.rateText }}
          </div>
          <div class="d-flex gc-4">
            <a
              class="text-decoration-none"
              :href="`/${doctorRate.doctor.url}`"
              target="_blank"
              rel="noopener noreferrer"
            >
              <v-img
                :src="doctorRate.doctor.avatar"
                :alt="t('Аватар', options)"
                width="48"
                height="48"
              />
            </a>
            <div class="d-flex flex-column">
              <a
                :href="`/${doctorRate.doctor.url}`"
                class="text-subtitle-1 text-decoration-none primary--text"
              >
                {{ transDynamic(doctorRate.doctor, `fio,${languageIso},${needTranslate}`) }}
              </a>
              <span class="text-body-1 text-info--text">
                {{ transDynamic(doctorRate.doctor, `meta,${languageIso},${needTranslate}`) }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed, onMounted, ref } from 'vue'
import I18NextVue from 'i18next'
import transDynamic from 'djanjucks/filters/transDynamic'
import useContextStore from 'src/store/useContextStore'
import type { ContextStore } from 'src/components/pages/profile/doctors/register/index/types'

const { t, language } = I18NextVue
const options = { ns: language }

const { context }: ContextStore = useContextStore()
const needTranslate = context.need_translate
const languageIso = context.current_language?.iso ?? ''

const props = defineProps<{
  doctorRates: Array<{
    doctor: {
      meta: string
      id: number
      avatar: string
      fio: string
      url: string
    }
    rateText: string
    width: string
  }>
}>()

const doctorRatesByLines = computed(() => {
  const halfIndex = Math.floor(props.doctorRates.length / 2)
  const ratesByLine = [props.doctorRates.slice(0, halfIndex), props.doctorRates.slice(halfIndex)]

  return ratesByLine.map(i => [...i, ...i])
})
const animationState = ref<'paused' | undefined>('paused')

onMounted(() => {
  animationState.value = undefined
})
</script>

<style lang="scss">
@keyframes sliding-line {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(calc(-50% + 8px));
  }
}

.sliding-line-cards {
  width: 100vw;

  &__line {
    display: flex;
    padding: 8px 0;
    animation: 40s sliding-line linear infinite;

    &:hover {
      animation-play-state: paused;
    }
  }
}
</style>
